export const figure21 = {
chart: {
type: 'line',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
height: 230,
plotBackgroundColor: null,
plotBorderWidth: null,
},
credits: {
enabled: false
},
title: {
text: 'جمهورية تنزانيا المتحدة'
},
subtitle: {
text: null
},
xAxis: {
categories: ['2009','2011','2013', '2015', '2019']
},
labels: {
format: '{value}',
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
},
},
yAxis: {
min: 0,
max: 3000,
tickInterval: 1000,
labels: {
format: '{value:,.0f}',
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
},
},      
title: {
text: null,
},
},
plotOptions: {
series: {
marker: {
	 enabled: false,
	 states: {
			  hover: {
					 enabled: false
				 }
		  }
 }
},			 
line: {
dataLabels: {
enabled: false
},
enableMouseTracking: true
}

},
legend: {
enabled: false,
},

colors: ['#5a99d3', '#f5b493','#a5a5a5', '#fdc201'],
series: [{
name: 'صغار المنتجين',
data: [276, 448, 425, 1173, 350]
}, {
name: 'منتجون على نطاق غير صغير',
data: [1206, 1617, 1172, 2108, 1393]
},{
name: 'صغار المنتجين من الإناث',
data: [218, 364, 364, 412, 240]
},{
name: 'صغار المنتجين من الذكور',
data: [302, 483, 451, 1531, 396]
}]
}

